import { MultiSelect } from '@mantine/core';
import classNames from './MultiSelect.module.css';

export default MultiSelect.extend({
  classNames,
  defaultProps: {
    checkIconPosition: 'right',
    clearable: true,
    searchable: true,
    size: 'md',
    withCheckIcon: true,
  },
  styles: () => ({
    wrapper: {
      overflow: 'visible !important',
    },
  }),
});
